/* Almla redesign: search overlay with typewriter prompts. Prompts come from the header section setting. */

(function(){
  var box = document.getElementById("almSearch");
  var input = document.getElementById("almSearchInput");
  if (!box || !input) return;

  // Typewriter prompts. Real product language, so the shopper learns what the
  // catalog is actually called while the cursor runs.
  var PROMPTS = JSON.parse(box.getAttribute("data-prompts") || "[]");
  if (!PROMPTS.length) PROMPTS = ["grip socks"];
  var pi = 0, ci = 0, dir = 1, timer = null;
  function tick(){
    var word = PROMPTS[pi];
    ci += dir;
    input.setAttribute("placeholder", word.slice(0, ci));
    var wait = dir > 0 ? 68 : 32;
    if (dir > 0 && ci >= word.length){ dir = -1; wait = 1500; }
    else if (dir < 0 && ci <= 0){ dir = 1; pi = (pi + 1) % PROMPTS.length; wait = 320; }
    timer = setTimeout(tick, wait);
  }
  function startType(){ if (!timer) tick(); }
  function stopType(){ clearTimeout(timer); timer = null; }

  function open(){
    box.classList.add("is-open");
    startType();
    setTimeout(function(){ input.focus({ preventScroll:true }); }, 60);
  }
  function close(){ box.classList.remove("is-open"); stopType(); }

  // No auto-open: the search bar now sits on the banner, so the shopper reaches
  // search when they want it rather than being met by a dialog on arrival.

  document.addEventListener("click", function(e){
    if (e.target.closest("[data-srch-close]")){ close(); return; }
    if (e.target.closest("[data-srch-open]")){ e.preventDefault(); open(); return; }
    var icon = e.target.closest(".alm-utils svg");
    if (icon && !e.target.closest(".alm-cart")){ e.preventDefault(); open(); }
  });
  input.addEventListener("input", function(){ if (input.value) stopType(); else startType(); });
  document.addEventListener("keydown", function(e){ if (e.key === "Escape") close(); });
})();

/* Header search bar types the same prompts as the overlay, on every page. */
(function(){
  var t = document.querySelector("[data-bnr-type]"), box = document.getElementById("almSearch");
  if (!t || !box || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  var WORDS = [];
  try { WORDS = JSON.parse(box.getAttribute("data-prompts") || "[]"); } catch (e) {}
  if (!WORDS.length) return;
  WORDS = ["Search"].concat(WORDS);
  var wi = 1, ci = 0, dir = 1;
  (function tick(){
    var w = WORDS[wi];
    ci += dir;
    t.textContent = w.slice(0, ci) || "Search";
    var wait = dir > 0 ? 70 : 34;
    if (dir > 0 && ci >= w.length){ dir = -1; wait = 1700; }
    else if (dir < 0 && ci <= 0){ dir = 1; wi = (wi + 1) % WORDS.length; if (!wi) wi = 1; wait = 380; }
    setTimeout(tick, wait);
  })();
})();
